import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Collections } from '../collections.model';
import { RequestDataPayload } from './actions';
import { BackendErrorResponse } from './backend';

export interface BackendErrorWrapper {
  readonly request: RequestDataPayload<any>;
  readonly error: BackendErrorResponse;
}

@Injectable()
export class BackendErrorHandler {
  private _errorStream: Rx.Subject<BackendErrorWrapper>;

  constructor() {
    this._errorStream = new Rx.Subject();
  }

  get errorStream() {
    return this._errorStream.asObservable();
  }

  getRequestErrors<K extends keyof Collections>(
    request: RequestDataPayload<K>,
  ): Rx.Observable<BackendErrorResponse> {
    return this._errorStream
      .asObservable()
      .pipe(
        filter(e =>
          e.request.clientRequestIds.some(id =>
            request.clientRequestIds.includes(id),
          ),
        ),
        map(e => e.error),
      );
  }

  handleBackendError<K extends keyof Collections>(
    request: RequestDataPayload<K>,
    response: BackendErrorResponse,
  ) {
    this._errorStream.next({
      request,
      error: response,
    });
  }
}
